import { render, staticRenderFns } from "./food-samples-page.vue?vue&type=template&id=5ea2547c"
import script from "./food-samples-page.vue?vue&type=script&lang=js"
export * from "./food-samples-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports